export default __webpack_public_path__ + "static/media/button talkback-7.3e142951.png";